// extracted by mini-css-extract-plugin
module.exports = {"benefit-text":"BenefitsModal_benefit-text__1IZz9","benefits-container":"BenefitsModal_benefits-container__si9tm"};